import { Outlet } from "react-router-dom";

const SuperAdminPortal = () => {
    return (
        <Outlet />
    )
}

export default SuperAdminPortal;